import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { min } from "lodash";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const PaymentModeRevenueChart = ({ data, reportType }) => {
  // Use date for days, month for months
  const labels = data.map(item => reportType === "months" ? item.month : item.date);

  const commonLineStyle = {
    tension: 0.4,
    borderDash: [6, 6],
    borderWidth: 2,
    pointRadius: 4,
    pointHoverRadius: 6,
    fill: false,
  };

  const chartData = {
    labels,
    datasets: [
      {
        label: "Cash",
        data: data.map(item => item.cash),
        borderColor: "#16a34a",
        ...commonLineStyle,
      },
      {
        label: "Card",
        data: data.map(item => item.card),
        borderColor: "#2563eb",
        ...commonLineStyle,
      },
      {
        label: "UPI",
        data: data.map(item => item.upi),
        borderColor: "#9333ea",
        ...commonLineStyle,
      },
      {
        label: "Credit",
        data: data.map(item => item.credit),
        borderColor: "#f97316",
        ...commonLineStyle,
      },
      {
        label: "Gift",
        data: data.map(item => item.gift),
        borderColor: "#ef4444",
        ...commonLineStyle,
      },
    ],
  };

  const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        usePointStyle: true,      // use a point/line instead of the square box
        pointStyle: "rect",        // show line instead of box
        boxWidth: 20,              // optional: size of the line marker
        generateLabels: (chart) => {
          return ChartJS.defaults.plugins.legend.labels.generateLabels(chart).map((label) => ({
            ...label,
            fillStyle: label.strokeStyle,  // remove the ash/gray fill
            strokeStyle: label.strokeStyle, // keep line color
            lineWidth: 2               // match dataset line width
          }));
        },
      },
    },
    tooltip: {
      backgroundColor: "#ffffff",
      titleColor: "#111827",
      bodyColor: "#111827",
      borderColor: "#e5e7eb",
      borderWidth: 1,
      callbacks: {
        title: (ctx) =>
          `${reportType === "months" ? "Month" : "Date"}: ${ctx[0].label}`,
        label: (ctx) =>
          `${ctx.dataset.label}: ₹${ctx.parsed.y.toLocaleString()}`,
        afterBody: (ctx) => {
          const index = ctx[0].dataIndex;
          const row = data[index];

          const total = row.cash + row.card + row.upi + row.credit + row.gift;
          return ["---------------------------", `Total: ₹${total.toLocaleString()}`];
        },
      },
    },
  },
  scales: {
    x: { grid: { display: false } },
    y: {
      min: 0,
      ticks: { callback: (value) => `₹${value / 1000}k` },
      grid: { borderDash: [4, 4] },
    },
  },
};


//   const options = {
//   responsive: true,
//   maintainAspectRatio: false,
//   plugins: {
//     legend: { position: "bottom" },
//     tooltip: {
//       backgroundColor: "#ffffff",
//       titleColor: "#111827",
//       bodyColor: "#111827",
//       borderColor: "#e5e7eb",
//       borderWidth: 1,
//       callbacks: {
//         title: (ctx) => {
//           // ctx is an array of hovered items
//           const index = ctx[0].dataIndex;
//           const label = reportType === "months" ? data[index].month : data[index].date;
//           return reportType === "months" ? `Month: ${label}` : `Date: ${label}`;
//         },
//         label: (ctx) => {
//           // show all payment modes and total
//           const index = ctx.dataIndex;
//           const item = data[index];

//           const cash = item.cash || 0;
//           const card = item.card || 0;
//           const upi = item.upi || 0;
//           const credit = item.credit || 0;
//           const gift = item.gift || 0;
//           const total = cash + card + upi + credit + gift;

//           return [
//             `Cash: ₹${cash.toLocaleString()}`,
//             `Card: ₹${card.toLocaleString()}`,
//             `UPI: ₹${upi.toLocaleString()}`,
//             `Credit: ₹${credit.toLocaleString()}`,
//             `Gift: ₹${gift.toLocaleString()}`,
//             `Total: ₹${total.toLocaleString()}`
//           ];
//         },
//       },
//     },
//   },
//   scales: {
//     x: { grid: { display: false } },
//     y: {
//       min: 0,
//       ticks: { callback: (value) => `₹${value / 1000}k` },
//       grid: { borderDash: [4, 4] },
//     },
//   },
// };

  return <Line data={chartData} options={options} />;
};


export default PaymentModeRevenueChart;
